export const arrow_up = {
	name: 'arrow-up',
	title: 'Arrow Up',
	content:
		'<path d="M 0.75,17.189L11.47,6.47c0.292-0.293,0.767-0.293,1.059-0.001c0,0,0.001,0.001,0.001,0.001l10.72,10.719" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
